import { commonTypes } from '../common';

const types = {
  SET_SIGNATURE_PHONE: 'APISNEEDS/SET_SIGNATURE_PHONE',
};

export const initialState = {
  phoneNumberOTP: null,
  phoneNumbersOTPToSelect: null,
};

const ApisNeedsR2RReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_LEGAL_TERMS_INFO: {
      const { phoneNumbersOTP } = action.payload;
      if (phoneNumbersOTP && Array.isArray(phoneNumbersOTP) && phoneNumbersOTP.length === 1 && phoneNumbersOTP[0].phoneNumber) {
        const phoneNumberOTP = phoneNumbersOTP[0].phoneNumber;
        return {
          ...state,
          phoneNumberOTP,
        };
      }

      return {
        ...state,
        phoneNumbersOTPToSelect: phoneNumbersOTP,
      };
    }
    case types.SET_SIGNATURE_PHONE: {
      const { phoneNumberOTP } = action.payload;
      return {
        ...state,
        phoneNumberOTP,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setSignaturePhone: phoneNumber => ({
    type: types.SET_SIGNATURE_PHONE,
    payload: {
      ...phoneNumber,
    },
  }),
};

export default ApisNeedsR2RReducer;
